const initState = {
  visitors: [],
  unBadgeVisitors: [],
};
const visitorReducer = (state = initState, action: any) => {
  switch (action.type) {
    case "FETCH_VISITORS":
      return {
        ...state,
        visitors: action.payload,
      };
    case "FETCH_UNBADGE_VISITORS":
      return {
        ...state,
        unBadgeVisitors: action.payload,
      };
    default:
      return {
        ...state,
      };
  }
};
export default visitorReducer;
